"use strict";
/**
 * Catapult REST API Reference
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.7.15
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
/**
* The entity type:
* 0x4158 (16728 decimal) - Blockchain Upgrade Transaction.
* 0x4159 (16729 decimal) - Network Config Transaction.
* 0x413D (16701 decimal) - Address Metadata Transaction.
* 0x423D (16957 decimal) - Mosaic Metadata Transaction.
* 0x433D (17213 decimal) - Namespace Metadata Transaction.
* 0x414D (16717 decimal) - Mosaic Definition Transaction.
* 0x424D (16973 decimal) - Mosaic Supply Change Transaction.
* 0x414E (16718 decimal) - Register Namespace Transaction.
* 0x424E (16974 decimal) - Address Alias Transaction.
* 0x434E (17230 decimal) - Mosaic Alias Transaction.
* 0x4154 (16724 decimal) - Transfer Transaction.
* 0x4155 (16725 decimal) - Modify Multisig Account Transaction.
* 0x4141 (16705 decimal) - Aggregate Complete Transaction.
* 0x4241 (16961 decimal) - Aggregate Bonded Transaction.
* 0x4148 (16712 decimal) - Hash Lock Transaction.
* 0x4150 (16720 decimal) - Account Properties Address Transaction.
* 0x4250 (16976 decimal) - Account Properties Mosaic Transaction.
* 0x4350 (17232 decimal) - Account Properties Entity Type Transaction.
* 0x4152 (16722 decimal) - Secret Lock Transaction.
* 0x4252 (16978 decimal) - Secret Proof Transaction.
* 0x414C (16716 decimal) - Account Link Transaction.
* 0x8043 (32835 decimal) - Nemesis block.
* 0x8143 (33091 decimal) - Regular block.
* 0x415D (16733 decimal) - Add Exchange Offer Transaction.
* 0x425D (16989 decimal) - Exchange Offer Transaction.
* 0x435D (17245 decimal) - Remove Exchange Offer Transaction.
* 0x4157 (16727 decimal) - Modify Contract Transaction.
* 0x415A (16730 decimal) - Prepare Drive Transaction.
* 0x425A (16986 decimal) - Join To Drive Transaction.
* 0x435A (17242 decimal) - Drive File System Transaction.
* 0x445A (17498 decimal) - Files Deposit Transaction.
* 0x455A (17754 decimal) - End Drive Transaction.
* 0x465A (18010 decimal) - Drive Files Reward Transaction.
* 0x475A (18266 decimal) - Start Drive Verification Transaction.
* 0x485A (18522 decimal) - End Drive Verification Transaction.
* 0x413F (16703 decimal) - Account Metadata_V2 Transaction
* 0x423F (16959 decimal) - Mosaic Metadata_V2 Transaction
* 0x433F (17215 decimal) - Namespace Metadata_V2 Transaction
* 0x434D (17229 decimal) - Mosaic Modify Levy Transaction
* 0x444D (17485 decimal) - Mosaic Remove Levy Transaction
*/
var EntityTypeEnum;
(function (EntityTypeEnum) {
    EntityTypeEnum[EntityTypeEnum["NUMBER_16728"] = 16728] = "NUMBER_16728";
    EntityTypeEnum[EntityTypeEnum["NUMBER_16729"] = 16729] = "NUMBER_16729";
    EntityTypeEnum[EntityTypeEnum["NUMBER_16701"] = 16701] = "NUMBER_16701";
    EntityTypeEnum[EntityTypeEnum["NUMBER_16957"] = 16957] = "NUMBER_16957";
    EntityTypeEnum[EntityTypeEnum["NUMBER_17213"] = 17213] = "NUMBER_17213";
    EntityTypeEnum[EntityTypeEnum["NUMBER_16717"] = 16717] = "NUMBER_16717";
    EntityTypeEnum[EntityTypeEnum["NUMBER_16973"] = 16973] = "NUMBER_16973";
    EntityTypeEnum[EntityTypeEnum["NUMBER_16718"] = 16718] = "NUMBER_16718";
    EntityTypeEnum[EntityTypeEnum["NUMBER_16974"] = 16974] = "NUMBER_16974";
    EntityTypeEnum[EntityTypeEnum["NUMBER_17230"] = 17230] = "NUMBER_17230";
    EntityTypeEnum[EntityTypeEnum["NUMBER_16724"] = 16724] = "NUMBER_16724";
    EntityTypeEnum[EntityTypeEnum["NUMBER_16725"] = 16725] = "NUMBER_16725";
    EntityTypeEnum[EntityTypeEnum["NUMBER_16705"] = 16705] = "NUMBER_16705";
    EntityTypeEnum[EntityTypeEnum["NUMBER_16961"] = 16961] = "NUMBER_16961";
    EntityTypeEnum[EntityTypeEnum["NUMBER_16712"] = 16712] = "NUMBER_16712";
    EntityTypeEnum[EntityTypeEnum["NUMBER_16720"] = 16720] = "NUMBER_16720";
    EntityTypeEnum[EntityTypeEnum["NUMBER_16976"] = 16976] = "NUMBER_16976";
    EntityTypeEnum[EntityTypeEnum["NUMBER_17232"] = 17232] = "NUMBER_17232";
    EntityTypeEnum[EntityTypeEnum["NUMBER_16722"] = 16722] = "NUMBER_16722";
    EntityTypeEnum[EntityTypeEnum["NUMBER_16978"] = 16978] = "NUMBER_16978";
    EntityTypeEnum[EntityTypeEnum["NUMBER_16716"] = 16716] = "NUMBER_16716";
    EntityTypeEnum[EntityTypeEnum["NUMBER_32835"] = 32835] = "NUMBER_32835";
    EntityTypeEnum[EntityTypeEnum["NUMBER_16703"] = 16703] = "NUMBER_16703";
    EntityTypeEnum[EntityTypeEnum["NUMBER_16959"] = 16959] = "NUMBER_16959";
    EntityTypeEnum[EntityTypeEnum["NUMBER_17215"] = 17215] = "NUMBER_17215";
    EntityTypeEnum[EntityTypeEnum["NUMBER_17229"] = 17229] = "NUMBER_17229";
    EntityTypeEnum[EntityTypeEnum["NUMBER_17485"] = 17485] = "NUMBER_17485";
})(EntityTypeEnum = exports.EntityTypeEnum || (exports.EntityTypeEnum = {}));
//# sourceMappingURL=entityTypeEnum.js.map